export const getReactSelectStyles = () => {
  const theme = {
    text: 'var(--text-primary)',
    muted: 'var(--text-muted)',
    menuBg: 'var(--bg-2)',
    inputBg: 'var(--input-bg)',
    border: 'var(--input-border)',
    hover: 'var(--row-hover)',
    primary: '#4680ff',
  };

  return {
    control: (base: any, state: any) => ({
      ...base,
      backgroundColor: theme.inputBg,
      borderColor: state.isFocused ? theme.primary : theme.border,
      boxShadow: state.isFocused ? '0 0 0 3px rgba(70, 128, 255, 0.1)' : 'none',
      minHeight: '41px',
      borderRadius: '8px',
      '&:hover': {
        borderColor: theme.primary,
      },
    }),
    menu: (base: any) => ({
      ...base,
      backgroundColor: theme.menuBg,
      border: `1px solid ${theme.border}`,
      zIndex: 9999,
      boxShadow: 'var(--dropdown-shadow)',
    }),
    menuList: (base: any) => ({
      ...base,
      backgroundColor: theme.menuBg,
      padding: '4px 0',
    }),
    option: (base: any, { isFocused, isSelected }: any) => ({
      ...base,
      backgroundColor: isSelected
        ? theme.primary
        : isFocused
          ? theme.hover
          : 'transparent',
      color: isSelected ? '#ffffff' : theme.text,
      cursor: 'pointer',
      padding: '10px 12px',
      fontSize: '14px',
      ':active': {
        backgroundColor: isSelected ? theme.primary : theme.hover,
      },
    }),
    multiValue: (base: any) => ({
      ...base,
      backgroundColor: theme.hover,
      borderRadius: '4px',
    }),
    multiValueLabel: (base: any) => ({
      ...base,
      color: theme.text,
    }),
    multiValueRemove: (base: any) => ({
      ...base,
      ':hover': {
        backgroundColor: '#ef4444',
        color: 'white',
      },
    }),
    singleValue: (base: any) => ({
      ...base,
      color: theme.text,
    }),
    placeholder: (base: any) => ({
      ...base,
      color: theme.muted,
    }),
    input: (base: any) => ({
      ...base,
      color: theme.text,
    }),
    indicatorSeparator: (base: any) => ({
      ...base,
      backgroundColor: theme.border,
    }),
    dropdownIndicator: (base: any) => ({
      ...base,
      color: theme.muted,
      ':hover': { color: theme.text },
    }),
    clearIndicator: (base: any) => ({
      ...base,
      color: theme.muted,
      ':hover': { color: '#ef4444' },
    }),
  };
};
